import querystring from 'querystring';
import { api, Auth } from '../../config/configuration/react';

const errors = {
  401: 'api_error_unauthorized',
  404: 'api_error_route_not_found',
  400: 'api_error_no_concessions',
  405: 'api_error_no_concessions',
  500: 'api_error_internal_error',
};

// Get API Buyers
export default async function getUsers(sources = null) {
  const userId = Auth.userId();
  const userRole = Auth.roleId();
  const userSources = Auth.sourceIds().join(',');
  const userCountry = Auth.country();
  const concessionId = Auth.concessionIds().join(',');

  let parameters = `filter={"ids":[${userId}]}&range=[0,999]&sort=["firstName","ASC"]`;
  if (sources) {
    parameters = `filter={"sourceIds":[${sources}]}&range=[0,999]&sort=["firstName","ASC"]`;
  } else if (userRole === 2) {
    parameters = `filter={"sourceIds":[${userSources}],"country":"${userCountry}"}&range=[0,999]&sort=["firstName","ASC"]`;
  } else if ([3, 5, 6].includes(userRole)) {
    parameters = `filter={"country":"${userCountry}"}&range=[0,999]&sort=["firstName","ASC"]`;
  } else if (userRole === 4) {
    parameters = `filter={"concessionIds":[${concessionId}]}&range=[0,999]&sort=["firstName","ASC"]`;
  }

  const response = await api('getUsers', null, querystring.parse(parameters));
  if (Object.prototype.hasOwnProperty.call(errors, response.status)) throw new Error(errors[response.status]);
  if (response.status > 299) throw new Error('api_error_internal_error');

  return response.data;
}
